import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSd: CultureInfo = {
  name: 'sd',
  displayName: 'Sindhi',
  iso3LanguageCode: 'snd',
  iso2LanguageCode: 'sd',
  ietfLanguageTag: 'sd',
  parent: null
};
